import { render } from "./OrderAction.vue?vue&type=template&id=0375b8ee&scoped=true"
import script from "./OrderAction.vue?vue&type=script&lang=js"
export * from "./OrderAction.vue?vue&type=script&lang=js"

import "./OrderAction.vue?vue&type=style&index=0&id=0375b8ee&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0375b8ee"]])

export default __exports__